/**
 * 工具类封装
 *
 */
import Vue from 'vue'
import store from '../store/index';
import {MessageBox} from 'element-ui';
import browser from 'browser-tool'

//删除本地所有缓存数据
export function cleanSession() {
  sessionStorage.clear();
  localStorage.clear();
  store.state.user = null;
  store.state.menus = null;
  store.state.token = null;
  store.state.navigation = null;
  store.state.menuActiveIndex = null;
  store.commit('setSearchStorage',null)
}

//下载工具,文件流解析
export function download(fileName,response) {
  //application/form-data
  var blob = new Blob([response.data]);
  const _fileName = fileName;
  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a');
    elink.download = _fileName;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else { // IE10+下载
    navigator.msSaveBlob(blob, _fileName);
  }

}
//转入登陆页面
//转入404页面
//转入500页面


const SEARCHOPTIONS = "searchOptions"
const OTHERS = "others"

/**
 *  添加本地检索项缓存数据
 * @param {Object} pageName 当前页名称
 * @param {Object} searchOptions 检索项数组，元素结构为｛"model名称","检索项值"｝，
 */
export function saveFormSession(pageName, searchOptions){
  store.commit('setSearchStorage',{
    pageName: pageName,
    searchOptions: searchOptions,
  })
}
/**
 *  添加本地检索项以外的缓存数据
 * @param {Object} pageName 当前页名称
 * @param {Object} searchOptions 检索项以外的缓存数据，元素结构为｛"key","value"｝，
 */
export function saveOhterSession(pageName, others){
  store.commit('setSearchStorage',{
    pageName: pageName,
    others: others,
  })
}
/**
 *  获取本地检索项缓存数据
 * @param {Object} pageName 当前页名称
 */
export function getFormSession(pageName){
  let pageInfo = store.getters.getSearchStorage(pageName)
  return pageInfo?pageInfo[SEARCHOPTIONS]:null
}
/**
 *  获取本地检索项以外缓存数据
 * @param {Object} pageName 当前页名称
 */
export function getOhterSession(pageName){
  let pageInfo = store.getters.getSearchStorage(pageName)
  return pageInfo?pageInfo[OTHERS]:null
}
// 把金额转换为千分位格式
export function formatMoneyToThousandth(val){
  //金额转换  保留2位小数 并每隔3位用逗号分开 1,234.56
  var str = (val/1).toFixed(2) + ''
  var intSum = str.substring(0,str.indexOf(".")).replace( /\B(?=(?:\d{3})+$)/g, ',' ) //取到整数部分
  var dot = str.substring(str.length,str.indexOf(".")) //取到小数部分搜索
  var ret = intSum + dot;
  return ret;
}

// 把千分位金额转换为普通格式
export function formatMoneyToNormal(val){
  if((val+"").Trim()==""){
     return"";
    }
    val=val.replace(/,/gi,'');
    return val;
}

/**
 * base64(加密/解密)
 * @param {String} str 跳转参数为base64字符串
 * @returns
 */
var  _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//加密
export function Base64encode(input) {
  var output = "";
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;
  input = _utf8_encode(input);
  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output = output +
      _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
      _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
  }
  return output;
}
//解密
export function Base64decode(input) {
  var output = "";
  var chr1, chr2, chr3;
  var enc1, enc2, enc3, enc4;
  var i = 0;
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  while (i < input.length) {
    enc1 = _keyStr.indexOf(input.charAt(i++));
    enc2 = _keyStr.indexOf(input.charAt(i++));
    enc3 = _keyStr.indexOf(input.charAt(i++));
    enc4 = _keyStr.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  output = _utf8_decode(output);
  return output;
}
// UTF-8编码的私有方法
var _utf8_encode = function (string) {
  string = string.toString().replace(/\r\n/g,"\n");
  var utftext = "";
  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);
    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }
  return utftext;
}

// UTF-8解码的私有方法
var  _utf8_decode = function (utftext) {
  var string = "";
  var i = 0;
  var c = 0;
  var c1 = 0;
  var c2 = 0;
  var c3 = 0;
  while ( i < utftext.length ) {
    c = utftext.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if((c > 191) && (c < 224)) {
      c2 = utftext.charCodeAt(i+1);
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i+1);
      c3 = utftext.charCodeAt(i+2);
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      i += 3;
    }
  }
  return string;
}

/**
 * 提示弹出窗，带倒计时
 * @param _title 标题
 * @param _message 内容
 * @param _type 类型，默认：info；success / info / warning / error
 * @param _countDownSeconds 倒计时（秒）默认：无
 * @param _callBack 回调函数
 * 示例
 *  this.$tool.alert("提示", "操作成功", "success", 10, function () {
 *         console.log("pn 回调")
 *       })
 *
 */
export function alert(_title, _message, _type, _countDownSeconds, _callBack) {

    //初始化
    _title = _title || "操作提示！";
    _message = _message || "";
    _type = _type || "info";
    _countDownSeconds = _countDownSeconds || 0;
    _callBack = _callBack || null;
    var timer = null;
    var _confirmButtonText = "确认";

    //定时器
    if (_countDownSeconds > 0) {
        var countDownSecondsSpanId = "mb_" + new Date().getTime();
        var count = _countDownSeconds;
        timer = setInterval(function () {
            count--;
            if (count <= 0) {
                MessageBox.close();
                clearInterval(timer);
                if (_callBack) {
                    _callBack()
                }
            }
            document.getElementById(countDownSecondsSpanId).innerHTML = count;
        }, 1000);

        _message = _message + "<div>（<span style='font-weight: 900' id='" + countDownSecondsSpanId + "'>" + _countDownSeconds + "</span> 秒后自动关闭）</div>";
    }

    //配置
    var options = {
        title: _title,
        message: _message,
        type: _type,
        showClose: false,
        confirmButtonText: _confirmButtonText,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        dangerouslyUseHTMLString: true,
        callback: function (action, instance) {
            clearInterval(timer);
            if (_callBack) {
                _callBack()
            }
        }
    }

    //开启
    MessageBox(options);

};

/**
 *  格式化值为数字类型：##.00
 * @param {val} 需要格式化的值
 * @return  ##.00,输入无法转换为有效数字，则返回空字符串,
 */
export function formatValToNumber(val){
  var formattedValue = "";
  var isNumber = /^-?\d+(\.\d+)?$/;
  if(isNumber.test(val)){
    // 将数字转换为字符串
    var numStr = val.toString();
    // 检查数字是否有小数部分
    var parts = numStr.split('.');
    if (parts.length === 1) {
      // 如果没有小数部分，则添加.00
      return parts[0] + '.00';
    } else {
      // 如果有小数部分，则截取前两位小数
      var decimalPart = parts[1].slice(0, 2);
      // 如果小数部分不足两位，用0填充
      if (decimalPart.length < 2) {
        decimalPart += '0'.repeat(2 - decimalPart.length);
      }
      // 拼接整数部分和小数部分
      formattedValue = parts[0] + '.' + decimalPart;
    }
  }
  return formattedValue;
}

/**
 * 将字符串转为全角
 * @param str
 * @returns {string}
 */
export function toDBC (str) {
  var result = "";
  var len = str.length;
  for (var i = 0; i < len; i++) {
    var cCode = str.charCodeAt(i);
    //全角与半角相差（除空格外）：65248(十进制)
    cCode = (cCode >= 0x0021 && cCode <= 0x007E) ? (cCode + 65248) : cCode;
    //处理空格
    cCode = (cCode == 0x0020) ? 0x03000 : cCode;
    result += String.fromCharCode(cCode);
  }
  return result;
};

/**
 * 将字符串转为大写
 * @param str
 * @returns {string}
 */
export function convertToUpperCase(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    result += str[i].toUpperCase();
  }
  return result;
}

/**
 * inCode
 * @param str
 * @returns {string}
 */
export function inCode(str) {
  // 假设的解码和编码映射字符串
  var decode2 = "1234567890";
  var encode2 = "o1Sdr3FjsD";
// 从某处（比如sessionStorage或localStorage）获取用户ID
  var oldString2 = str; // 使用默认值以防没有用户ID
// 初始化新字符串和随机字符串
  var newString2 = "";
  var anything2 = "";

// 获取oldString2的长度
  var maxi2 = oldString2.length;

// 编码过程
  for (var i = 0; i < maxi2; i++) {
    // 在decode2中查找oldString2的当前字符的索引
    var index = decode2.indexOf(oldString2[i]);
    // 如果找到了索引，从encode2中取出对应的字符
    if (index !== -1) {
      newString2 += encode2[index];
    }
  }

// 生成随机字符
  for (var a = 0; a < 10; a++) {
    // 生成一个随机ASCII码（48-57是数字，65-90是大写字母，97-122是小写字母）
    var intTemp2 = Math.floor(Math.random() * (122 - 48 + 1)) + 48;
    var strTemp2 = "";
    // 确保生成的字符在指定的范围内
    if ((intTemp2 >= 48 && intTemp2 <= 57) || (intTemp2 >= 65 && intTemp2 <= 90) || (intTemp2 >= 97 && intTemp2 <= 122)) {
      strTemp2 = String.fromCharCode(intTemp2);
    }
    // 将随机字符添加到anything2中
    anything2 += strTemp2;
  }

  // 拼接最终字符串
  newString2 += "c" + anything2;

  // 输出结果
  return newString2;
}

/**
 *  如果是非Edge，Chrome浏览器返回false
 * @return {Promise} Promise.then(result => {})
 */
export function checkBrowser(){
  return new Promise((resolve, reject) => {
    browser.getInfo().then(result => {
      var browserName = result.browser;
      if (browserName === 'Edge' || browserName === 'Chrome') {
        resolve(true); // 如果浏览器是 Edge 或 Chrome，解析为 true
      } else {
        resolve(false); // 如果不是，解析为 false
      }
    }).catch(err => {
      reject(err); // 如果 getInfo() 抛出错误，拒绝 Promise
    });
  });
}




// WEBPACK FOOTER //
// ./src/utils/tool.js